export default {
  updateState(state, {field, value}) {
    state[field] = value
  },
  updateForm(state, {field, value}) {
    state.form[field] = value
  }
}
